import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Actualizaciones from './components/Actualizaciones';
import { registerServiceWorker } from './utils/pwa';

const root = ReactDOM.createRoot(document.getElementById('root'));
/* Actualizaciones va afuera de App, al lado: es de la app entera y tiene que
   seguir vivo pase lo que pase adentro, en los tres entornos por igual. */
root.render(<><App /><Actualizaciones /></>);

registerServiceWorker();
